import { createStore, applyMiddleware, compose } from 'redux';
import promiseMiddleware from 'redux-promise-middleware';
import thunk from 'redux-thunk';
import { hashHistory } from 'react-router';
import { routerMiddleware } from 'react-router-redux';
import { autoRehydrate } from 'redux-persist';
import reducer from '../reducers';
import { PromiseTypeSuffixes as promiseTypeSuffixes } from '../constants';

const router = routerMiddleware(hashHistory);

const promise = promiseMiddleware({
  promiseTypeSuffixes
});

const createStoreWithMiddleware = compose(
  applyMiddleware(
    thunk,
    promise,
    router
  ),
  autoRehydrate({ log: false }),
  // window.devToolsExtension ? window.devToolsExtension() : f => f,
  window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f// && window.__REDUX_DEVTOOLS_EXTENSION__
)(createStore);

function configureStore(initialState) {
  return createStoreWithMiddleware(reducer, initialState);
}

export default configureStore;
